import { t } from '../i18n'

/** Источник поля волнения: реальный CMEMS (VHM0) или оценка по ветру. */
export type WaveSource = 'cmems' | 'wind' | null | undefined

/**
 * Подпись легенды волнения. Реальные волны показываем без оговорок, оценку по
 * ветру (Пирсон–Московиц) называем оценкой — за реальные данные её не выдаём.
 */
export function waveLegendLabel(source: WaveSource): string {
  // Со строчной: строка стоит в общей легенде рядом с «изотерма», «фронты»,
  // «изобаты» — заглавная выбивалась бы из ряда.
  return source === 'cmems' ? t('maps.waves.real') : t('maps.waves.estimated')
}
